import { useCallback, useEffect } from 'react';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';

export function useTour(tourKey, getSteps) {
  const startTour = useCallback(() => {
    const steps = getSteps();
    if (!steps.length) return;
    const d = driver({
      showProgress: true,
      showButtons: ['next', 'previous', 'close'],
      nextBtnText: 'Next →',
      prevBtnText: '← Back',
      doneBtnText: 'Done',
      overlayOpacity: 0.6,
      onDestroyed: () => {
        localStorage.setItem(`tour_seen_${tourKey}`, '1');
      },
      steps,
    });
    d.drive();
  }, [tourKey, getSteps]);

  const startIfNew = useCallback(() => {
    if (!localStorage.getItem(`tour_seen_${tourKey}`)) {
      setTimeout(startTour, 700);
    }
  }, [tourKey, startTour]);

  useEffect(() => {
    const handler = (e) => {
      if (e.detail === tourKey) startTour();
    };
    window.addEventListener('start-tour', handler);
    return () => window.removeEventListener('start-tour', handler);
  }, [tourKey, startTour]);

  return { startTour, startIfNew };
}
